import { render, staticRenderFns } from "./Train.vue?vue&type=template&id=1e2bb119&scoped=true&"
import script from "./Train.vue?vue&type=script&lang=js&"
export * from "./Train.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2bb119",
  null
  
)

export default component.exports